import { Filter } from "model/Filter/Filter";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Panel } from "components/Panel/Panel";
import { buildTourPath } from "pages/PageConfigs";
import { SingleColumnPage } from "pages/PageTemplates";
import { ColumnContainer, GrowColumn } from "pages/styles";
import { Theme } from "model/Theme";
import { getTourTournamentIds, Tour } from "model/Tour/Tour";
import { TourHeader } from "components/Tabs/Tour/TourHeader";
import { TourMatchesTab } from "components/Tabs/Tour/TourMatchesTab";
import { TournamentsList } from "components/Tournaments/TournamentsList";
import { TourLeaderboardTab } from "components/Tabs/Tour/TourLeaderboardTab";
// import { TourOverviewTab } from "components/Tabs/Tour/TourOverviewTab";

interface Props {
  tour: Tour;
  tabName: string | undefined;
}

export const TourPageContent = ({ tour, tabName }: Props) => {
  const tabOptions = ["Leaderboard", "Tournaments", "Matches"];

  const [selectedTab, setSelectedTab] = useState(
    !!tabName && tabOptions.includes(tabName) ? tabName : tabOptions[0]
  );

  const tabFilter: Filter<string> = {
    options: tabOptions,
    selectedValue: selectedTab,
    setSelectedValue: setSelectedTab,
  };

  const navigate = useNavigate();
  useEffect(() => {
    navigate(buildTourPath(tour.id, selectedTab), {
      replace: true,
    });
  }, [selectedTab]);

  return (
    <SingleColumnPage>
      <Panel>
        <TourHeader tour={tour} tabFilter={tabFilter} />
      </Panel>
      <ColumnContainer>
        {getTabContent(
          tabFilter.selectedValue,
          tour.id,
          tour,
          getTourTournamentIds(tour),
          tour.theme
        )}
      </ColumnContainer>
    </SingleColumnPage>
  );
};

const getTabContent = (
  selectedTab: string,
  tourId: string,
  tour: Tour,
  tournamentIds: string[],
  theme: Theme | undefined
) => {
  switch (selectedTab) {
    // case "Overview":
    //   return (
    //     <TourOverviewTab key={selectedTab} tour={tour} orgTime={orgTime} />
    //   );
    case "Leaderboard":
      return <TourLeaderboardTab tour={tour} />;
    case "Tournaments":
      return (
        <GrowColumn>
          <TournamentsList tournamentIds={tournamentIds} tourIds={[]} />
        </GrowColumn>
      );
    case "Matches":
      return <TourMatchesTab key={selectedTab} tourId={tourId} theme={theme} />;
    default:
      return <></>;
  }
};
